import axios from "axios";
import {
  API_VALIDATE_APP_NAME_ENDPOINT,
  API_LIST_CATEGORIES_ENDPOINT,
  API_GET_CLIENT_CREDENTAILS_ENDPOINT,
  API_ROTATE_CLIENT_CREDENTAILS_ENDPOINT,
  API_FEEDBACK_ENDPOINT,
  API_LISTING_ENDPOINT,
  API_GET_APPLICATION_BY_ID_ENDPOINT,
  API_CREATE_APPLICATION_ENDPOINT,
  API_UPDATE_APPLICATION_ENDPOINT,
  API_APPLICATION_LISTING_ENDPOINT,
  API_META_DATA_ENDPOINT,
  API_GET_API_BY_ID_ENDPOINT,
  API_GET_TOP_APIS_ENDPOINT,
  API_GET_CATEGORY_ENDPOINT,
  API_LIST_CATEGORIES_OPEN_ENDPOINT,
  API_GET_CATEGORY_OPEN_ENDPOINT,
  API_LISTING_OPEN_ENDPOINT,
  API_GET_API_BY_ID_OPEN_ENDPOINT,
  API_GLIMPSE_ENDPOINT,
  API_GET_API_CONSUMPTION_ANALYTICS_ENDPOINT,
  API_GET_WORKFLOW_EXECUTION_ANALYTICS_ENDPOINT,
  API_GET_SCHEDULED_JOB_ANALYTICS_ENDPOINT,
  API_GET_API_LATENCY_ANALYTICS_ENDPOINT,
  API_GET_USER_ANALYTICS_ENDPOINT,
  API_MANAGE_API_SUBSCRIPTIONS_ENDPOINT,
  API_LIST_CONNECTOR_LOGS_ENDPOINT,
  API_MANAGE_API_ACCESS_ENDPOINT,
  API_LIST_USER_APIACCESS_DETAILS_ENDPOINT,
  API_LIST_API_SUBSCRIPTIONS,
  API_GET_CAPTCHA_ENDPOINT,
  API_LIST_SCHEDULED_JOB_EXECUTION_RESULT_ENDPOINT,
  API_LIST_WORKFLOW_EXECUTION_RESULT_ENDPOINT,
  API_GET_WORKFLOW_EXECUTION_RESULT_ENDPOINT,
  API_GET_APPLICATION_WISE_API_ANALYTICS_ENDPOINT,
  API_GET_USER_WISE_API_ANALYTICS_ENDPOINT,
  API_GET_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT,
  API_GET_APPLICATION_WISE_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT,
  API_GET_API_MANAGEMENT_DETAILS_ENDPOINT,
  API_GET_API_CONSUMPTION_TRENDS_ANALYTICS_ENDPOINT,
  API_GET_API_LATENCY_REPORT_ANALYTICS_ENDPOINT,
  API_GET_USER_WISE_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT,
  API_GET_API_CONSUMPTION_METRICS_ENDPOINT,
  API_GET_OVERALL_APIS_CONSUMERS_ENDPOINT,
  API_GET_OVERALL_APIS_ENDPOINT,
  API_GET_TOP_APIS_CONSUMERS_ENDPOINT,
  API_TRIGGER_REPORT_DOWNLOAD_ENDPOINT,
  API_LIST_APIGATEWAY_IDS,
  API_LIST_APISTAGE_IDS,
} from "../globals/constants";

export const listCategoriesApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_LIST_CATEGORIES_ENDPOINT,
    req
  );
};

export const listCategoriesOpenApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_LIST_CATEGORIES_OPEN_ENDPOINT,
    req
  );
};

export const getCategoryByIdApi = (id) => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + API_GET_CATEGORY_ENDPOINT + "/" + id
  );
};

export const getCategoryByIdOpenApi = (id) => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + API_GET_CATEGORY_OPEN_ENDPOINT + "/" + id
  );
};

export const apiListingApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_LISTING_ENDPOINT,
    req
  );
};

export const apiListingOpenApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_LISTING_OPEN_ENDPOINT,
    req
  );
};

export const getApiByIdApi = (id) => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + API_GET_API_BY_ID_ENDPOINT + "/" + id
  );
};

export const getApiByIdOpenApi = (id) => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_API_BY_ID_OPEN_ENDPOINT +
      "/" +
      id
  );
};

export const getGlimpseApi = (config = {}) => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + API_GLIMPSE_ENDPOINT,
    config
  );
};

export const getOverAllApisDataApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_OVERALL_APIS_ENDPOINT,
    req
  );
};

export const downloadReportsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_REPORTS_URL + API_TRIGGER_REPORT_DOWNLOAD_ENDPOINT,
    req
  );
};

export const getTopApisDataApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_TOP_APIS_ENDPOINT,
    req
  );
};

export const getOverAllConsumersDataApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_OVERALL_APIS_CONSUMERS_ENDPOINT,
    req
  );
};

export const getTopConsumersDataApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_TOP_APIS_CONSUMERS_ENDPOINT,
    req
  );
};

export const getApiConsumptionMetricsData = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_API_CONSUMPTION_METRICS_ENDPOINT,
    req
  );
};

export const getApiConsumptionAnalyticsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_API_CONSUMPTION_ANALYTICS_ENDPOINT,
    req
  );
};

export const getWorkflowExecutionAnalyticsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_WORKFLOW_EXECUTION_ANALYTICS_ENDPOINT,
    req
  );
};

export const getScheduledJobExecutionAnalyticsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_SCHEDULED_JOB_ANALYTICS_ENDPOINT,
    req
  );
};

export const getApiLatencyAnalyticsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_API_LATENCY_ANALYTICS_ENDPOINT,
    req
  );
};

export const getUserOnboardingAnalyticsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_USER_ANALYTICS_ENDPOINT,
    req
  );
};

export const getApplicationWiseAPIConsumptionReportsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_APPLICATION_WISE_API_ANALYTICS_ENDPOINT,
    req
  );
};

export const getUserWiseAPIConsumptionReportsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_USER_WISE_API_ANALYTICS_ENDPOINT,
    req
  );
};

export const getAPILatencyReportsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_API_LATENCY_REPORT_ANALYTICS_ENDPOINT,
    req
  );
};

export const getAPIConsumptionsStatusCodeWiseReportsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT,
    req
  );
};

export const getApplicationWiseAPIConsumptionsStatusCodeWiseReportsApi = (
  req
) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_APPLICATION_WISE_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT,
    req
  );
};

export const getUserWiseAPIConsumptionsStatusCodeWiseReportsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_USER_WISE_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT,
    req
  );
};

export const getApiManagementReportsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_GET_API_MANAGEMENT_DETAILS_ENDPOINT,
    req
  );
};

export const getAPIConsumptionTrendsReportsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_API_CONSUMPTION_TRENDS_ANALYTICS_ENDPOINT,
    req
  );
};

export const applicationListingApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_APPLICATION_LISTING_ENDPOINT,
    req
  );
};

export const validateAppNameApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_VALIDATE_APP_NAME_ENDPOINT,
    req
  );
};

export const getApplicationByIdApi = (id) => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_APPLICATION_BY_ID_ENDPOINT +
      "/" +
      id
  );
};

export const createApplicationApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_CREATE_APPLICATION_ENDPOINT,
    req
  );
};

export const updateApplicationApi = (req, id) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_UPDATE_APPLICATION_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const manageApiSubscriptionsForApplicationApi = (req, id) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_MANAGE_API_SUBSCRIPTIONS_ENDPOINT +
      "/" +
      id,
    req
  );
};

export const manageApiAccessForApi = (req, config = {}) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_MANAGE_API_ACCESS_ENDPOINT,
    req,
    {
      params: config,
    }
  );
};

export const getClientCredentialsApi = () => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + API_GET_CLIENT_CREDENTAILS_ENDPOINT
  );
};

export const rotateClientCredentialsApi = () => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + API_ROTATE_CLIENT_CREDENTAILS_ENDPOINT
  );
};

export const listConnectorLogsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_LIST_CONNECTOR_LOGS_ENDPOINT,
    req
  );
};

export const listApiAccessRequestApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_LIST_USER_APIACCESS_DETAILS_ENDPOINT,
    req
  );
};

export const listApiSubscriptions = (id) => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + API_LIST_API_SUBSCRIPTIONS + "/" + id
  );
};

export const feedbackApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_FEEDBACK_ENDPOINT,
    req
  );
};

export const getMetaDataApi = () => {
  return axios.get(process.env.REACT_APP_PORTAL_URL + API_META_DATA_ENDPOINT);
};

export const getTNCApi = () => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + `${API_META_DATA_ENDPOINT}?tnc=true`
  );
};

export const getPPApi = () => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + `${API_META_DATA_ENDPOINT}?pp=true`
  );
};

export const getFAQApi = () => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + `${API_META_DATA_ENDPOINT}?faq=true`
  );
};

export const getCaptchaApi = () => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL + API_GET_CAPTCHA_ENDPOINT,
    {
      params: {
        font: 20,
      },
    }
  );
};

export const listScheduledJobExecutionResult = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_LIST_SCHEDULED_JOB_EXECUTION_RESULT_ENDPOINT,
    req
  );
};

export const listWorkflowExecutionResult = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL +
      API_LIST_WORKFLOW_EXECUTION_RESULT_ENDPOINT,
    req
  );
};

export const getWorkflowExecutionResult = (requestId) => {
  return axios.get(
    process.env.REACT_APP_PORTAL_URL +
      API_GET_WORKFLOW_EXECUTION_RESULT_ENDPOINT +
      "/" +
      requestId
  );
};

export const listApiGatewayIdsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_LIST_APIGATEWAY_IDS,
    req
  );
};

export const listApiStageIdsApi = (req) => {
  return axios.post(
    process.env.REACT_APP_PORTAL_URL + API_LIST_APISTAGE_IDS,
    req
  );
};
